import React from 'react';
import PropTypes from 'prop-types';
import withLoading from '../../../utils/composition/withLoading';
import { Pagination } from '../../../v4/components';
import { dataProps, paginationProps } from '../../../data/enums/Component';
import ReportTableStyled from '../ReportTableStyled';
import { COVERAGE_TYPE } from '../../../data/enums/GraphQL';

const propTypes = {
  data: dataProps.value,
  pagination: paginationProps.value,
  onPageChange: PropTypes.func,
  handleRowClick: PropTypes.func,
  TableBody: PropTypes.func.isRequired,
  TableHeader: PropTypes.func.isRequired,
  viewType: PropTypes.string,
};

const defaultProps = {
  data: dataProps.defaultValue,
  pagination: paginationProps.defaultValue,
  onPageChange: () => null,
  handleRowClick: () => null,
  viewType: COVERAGE_TYPE.CHANNEL,
};

const View = ({ ...props }) => {
  const { data, onPageChange, pagination, handleRowClick, TableHeader, TableBody, viewType } = props;

  return (
    <ReportTableStyled>
      <div className={`table-wrap ${viewType.toLowerCase()}`}>
        <table>
          <TableHeader viewType={viewType} />
          <tbody>
            {data.list.map((coverage) => (
              <TableBody data={coverage} onRowClick={handleRowClick} viewType={viewType} key={coverage.id} />
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={pagination.page}
        limit={pagination.limit}
        totalItems={data.total}
        onPageChange={onPageChange}
      />
    </ReportTableStyled>
  );
};

View.propTypes = propTypes;

View.defaultProps = defaultProps;

const LoginViewWithErrorAndLoading = withLoading(View);

export default LoginViewWithErrorAndLoading;
